import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setConversionCampaignCommissionsFilters } from '../../redux-stores/slices/conversionCampaignSlice';
import { AppDispatch, RootState } from '../../redux-stores/store';
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent';
import './ConversionCampaignCommissionPeriodFilters.scss';

type PeriodFilter = { label: string; start_date: string; end_date: string; month: string };

const CheckIcon = ({ className }: { className?: string }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3333 4L6.66667 10.6667L3.33333 7.33333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

const ConversionCampaignCommissionPeriodFilters = ({ onClose }: { onClose: () => void }) => {
    const dispatch = useDispatch<AppDispatch>();
    const filters = useSelector((state: RootState) => state.conversionCampaigns.commissions.applied_filters);

    const getPastMonthsRange = (months: number) => {
        const start = moment().subtract(months, 'months').startOf('month');
        const end = moment().subtract(1, 'months').endOf('month');

        return {
            label: `Past ${months} Months`,
            start_date: start.format('YYYY-MM-DD'),
            end_date: end.format('YYYY-MM-DD'),
            month: `${start.format('YYYY-MM-DD')} - ${end.format('YYYY-MM-DD')}`
        };
    };

    const currentMonth = {
        label: moment().format('MMMM'),
        start_date: moment().startOf('month').format('YYYY-MM-DD'),
        end_date: moment().endOf('month').format('YYYY-MM-DD'),
        month: moment().format('YYYY-MM')
    }

    const lastMonth = {
        label: moment().subtract(1, 'month').format('MMMM'),
        start_date: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        end_date: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        month: moment().subtract(1, 'month').format('YYYY-MM')
    }
    const past3Months = getPastMonthsRange(3);

    const past6Months = getPastMonthsRange(6);

    const currentYear = {
        label: 'Current Year',
        start_date: moment().startOf('year').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        month: `${moment().startOf('year').format('YYYY-MM-DD')} - ${moment().format('YYYY-MM-DD')}`
    };


    const lastYear = {
        label: 'Last Year',
        start_date: moment()
            .subtract(1, 'year')
            .startOf('year')
            .format('YYYY-MM-DD'),
        end_date: moment()
            .subtract(1, 'year')
            .endOf('year')
            .format('YYYY-MM-DD'),
        month: `${moment()
            .subtract(1, 'year')
            .startOf('year')
            .format('YYYY-MM-DD')} - ${moment()
                .subtract(1, 'year')
                .endOf('year')
                .format('YYYY-MM-DD')}`
    };

    const last5MonthsOfThisYear = Array.from(
        { length: moment().month()+1 },
        (_, i) => {
            const m = moment().startOf('year').add(i, 'months');

            return {
                label: m.format('MMMM'),
                start_date: m.startOf('month').format('YYYY-MM-DD'),
                end_date: m.endOf('month').format('YYYY-MM-DD'),
                month: m.format('YYYY-MM')
            };
        }
    ).reverse().splice(0, 5); 

    const applyFilter = (period: PeriodFilter) => {
        if (filters.month === period.month) {
            dispatch(setConversionCampaignCommissionsFilters({}));
        } else {
            dispatch(setConversionCampaignCommissionsFilters({ ...filters, month: period.month, start_date: period.start_date, end_date: period.end_date }));
        }
        onClose();
    };

    const quickFilters: Array<{ displayLabel: string; value: PeriodFilter }> = [
        { displayLabel: 'Current Month', value: currentMonth },
        { displayLabel: 'Last Month', value: lastMonth },
        { displayLabel: 'Past 3 Months', value: past3Months },
        { displayLabel: 'Past 6 Months', value: past6Months },
        { displayLabel: 'Current Year', value: currentYear },
        { displayLabel: 'Last Year', value: lastYear },
    ];

    return (
        <div className="cc-period-filters">
            <div className="cc-period-filters__section pt-3">
                {quickFilters.map((item, idx) => {
                    const isActive = filters.month === item.value.month;
                    return (
                        <button
                            key={item.displayLabel}
                            type="button"
                            className={`cc-period-filters__row ${isActive ? 'is-active' : ''} ${idx === quickFilters.length - 1 ? 'is-last' : ''}`}
                            onClick={() => applyFilter(item.value)}
                        >
                            <span className="cc-period-filters__label">{item.displayLabel}</span>
                            {isActive && <CheckIcon className="cc-period-filters__check" />}
                        </button>
                    );
                })}
            </div>

            <div className="cc-period-filters__gap" />

            <div className="cc-period-filters__section">
                {last5MonthsOfThisYear.map((m, idx) => {
                    const isActive = filters.month === m.month;
                    return (
                        <button
                            key={m.month}
                            type="button"
                            className={`cc-period-filters__row ${isActive ? 'is-active' : ''} ${idx === last5MonthsOfThisYear.length - 1 ? 'is-last' : ''}`}
                            onClick={() => applyFilter(m)}
                        >
                            <span className="cc-period-filters__label">{m.label}</span>
                            {isActive && <CheckIcon className="cc-period-filters__check" />}
                        </button>
                    );
                })}
            </div>
        </div>
    )
}

export default withSlideUpModal(ConversionCampaignCommissionPeriodFilters, undefined, true)